const protectedRoutes = [
  '/checkout/req-callback-success',
  '/my-events/[userEventId]/event-cart-details',
  '/my-orders',
  '/my-orders/[orderId]/order-details',
  '/user-profile',
  '/user-profile/address',
  '/user-profile/get-help',
  '/user-profile/my-events',
  '/user-profile/personal-details'
];

const isProtectedRoute = (route) =>
  protectedRoutes.some((protectedRoute) => {
    const protectedSegments = protectedRoute.split('/');
    const routeSegments = route.split('/');

    if (protectedSegments.length !== routeSegments.length) return false;

    return protectedSegments.every(
      (seg, i) => seg.startsWith('[') || seg === routeSegments[i]
    );
  });

export default isProtectedRoute;
